import Vue from 'vue'
import * as firebase from 'firebase/app';
import 'firebase/app'
import 'firebase/auth'
import {config} from './config'
// import 'firebase/firestore'

const fb = firebase.initializeApp(config)

Vue.prototype.$firebase = fb